module.exports = __webpack_public_path__ + "img/logo-full-white.7725bb6d.png";